import { collectionEngineV1 } from '../apis';
const req = collectionEngineV1('/connect');
export const connectionsById = (id) => req('GET', `/connections/${id}`);
export const productsById = (id) => req('GET', `/products/${id}`);
export const connectionsFrom = () => req('GET', `/connections/from`);
export const connections = () => req('GET', `/connections`);
export const getMappingCreditorLink = (id) => req('GET', `/mappings/${id}/creditor-link`);
export const getCaseMappingsOnCase = (id) => req('GET', `/mappings/by-case-id/${id}`);
export const getCaseMapping = (id) => req('GET', `/mappings/${id}`);
export const getCaseMappingsOnConnection = (connectionId) => req('GET', `/connections/${connectionId}/mappings`);
export const getEntityMappings = (id) => req('GET', `/mappings/by-case-id/${id}/entity-mappings`);
//# sourceMappingURL=connect.js.map